import { Directive } from '@angular/core';
import teamData from '../data/team.json';
import {Team} from '../models/iteam'

@Directive()
export class TeamHelperService {
  page: number = 1;
  public teamblock: Team[] = teamData;
  public visible : boolean = false;
  constructor() { }
  socialtrigger(item: { visible: boolean; }){
    item.visible = !item.visible;
  }
}
